const galleryimage  = [
  { src: 'gallery1.jpg', alt: 'Image 1' },
  { src: 'gallery2.jpg', alt: 'Image 2' },
  { src: 'gallery3.jpg', alt: 'Image 3' },

  { src: 'gallery7.jpg', alt: 'Image 7' },
  { src: 'gallery8.jpg', alt: 'Image 8' },
  { src: 'gallery9.jpg', alt: 'Image 9' },
  { src: 'gallery10.jpg', alt: 'Image 10' },
  
  { src: 'gallery13.JPG', alt: 'Image 13' },
  
  { src: 'gallery18.jpg', alt: 'Image 18' },
  
  { src: 'gallery21.JPG', alt: 'Image 21' },
  { src: 'gallery22.jpeg', alt: 'Image 22' },
  { src: 'gallery23.jpeg', alt: 'Image 23' },
  
  { src: 'gallery25.jpeg', alt: 'Image 25' },
  { src: 'gallery26.jpeg', alt: 'Image 26' },
  
  { src: 'gallery28.jpeg', alt: 'Image 28' },
  { src: 'gallery29.jpeg', alt: 'Image 29' },
  
  { src: 'gallery35.jpeg', alt: 'Image 35' },
  { src: 'gallery36.jpeg', alt: 'Image 36' },
  { src: 'gallery37.jpeg', alt: 'Image 37' },
  { src: 'gallery38.jpeg', alt: 'Image 38' },
  { src: 'gallery39.jpg', alt: 'Image 39' },
  
  ];
  export default galleryimage;